export const distributionsFragment = `
participantDistributions {
    fundraiserPageDisplayAmountType {
      fundraiserPageDisplayAmountTypeId
      name
      description
    }
    fundraiserPageDisplayDonorType {
      fundraiserPageDisplayDonorTypeId
      name
      description
    }
    donorName
    donorEmail
    recurringFlag
    donorCity
    donorMatchingCompanyName
    donorAddress2
    donorPhoneNumber
    participantDistributionsId
    participantFundsId
    companyMatching
    fundDate
    paymentMethod
    donorMessage
    donationDescription
    amount
    donorAddress1
    status
    donorDisplayName
    donorAreaCode
    fundType
    type
    donorPostalCode
    donorCountry
    donorState
    source
    honoree
    donorMessageId
    showComments
    hasDcf
}
`;
